<template>
  <div class="login_cont_box">
    <div class="login_data">
      <img class="close" src="@/assets/close_icon.png" @click="CloseComRegModal" />
      <div class="tabs">
        <div class="tab active">企业注册</div>
      </div>
      <div class="form_cont">
        <ul>
          <li class="build"><input type="text" v-model="formData.company_name" placeholder="请输入您的企业名称" /></li>
          <li class="card"><input type="text" v-model="formData.danwei_social_code" placeholder="请输入统一社会信用代码" /></li>
          <li class="gonghui select">
            <input type="text" v-model="unitSelect" readonly placeholder="请选择您的所属工会" @click="optionsShow=!optionsShow" />
            <div class="options" v-show="optionsShow">
              <div class="option" :class="{'active': item.id==formData.admin_id}" v-for="item in unitList" @click="optionClick(item)">{{ item.username }}</div>
            </div>
          </li>
          <li class="user"><input type="text" v-model="formData.username" placeholder="请输入联系人" /></li>
          <li class="phone"><input type="number" v-model="formData.mobile" placeholder="请输入联系人手机号" /></li>
          <li class="pass"><input type="password" autocomplete="new-password" v-model="formData.password" placeholder="请输入密码" /></li>
        </ul>
        <div class="btn" @click="submitBtn">注册</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "list",
  components: {},

  data() {
    return {
      tabActive: 1,
      formData: {},
      optionsShow: false,
      unitList: [], //工会
      unitSelect: ''
    };
  },
  mounted() {
    this.getUnit();
  },
  methods: {
    ...mapMutations(['CloseLoginModal', 'CloseComRegModal', 'ShowTipModal', 'ClearUserInfo']), //登录弹窗
    getUnit(){
      this.$axios.post(`/reservation/unit`).then(res => {
        if (res.code == 1) {
          this.unitList = res.data;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    optionClick(item){
      this.formData.admin_id = item.id;
      this.unitSelect = item.username;
      this.optionsShow = false;
    },
    // 注册按钮
    submitBtn() {
      if (!this.formData.company_name) {
        return this.$message.error('请输入您的企业名称');
      }

      if (!this.formData.danwei_social_code) {
        return this.$message.error('请输入统一社会信用代码')
      }

      if (!this.formData.admin_id) {
        return this.$message.error('请选择您的所属工会')
      }

      if (!this.formData.username) {
        return this.$message.error('请输入联系人')
      }

      if (!this.formData.mobile) {
        return this.$message.error('请输入联系人手机号')
      }else if(this.formData.mobile.length != 11){
        return this.$message.error('请输入正确的手机号')
      }

      if (!this.formData.password) {
        return this.$message.error('请输入密码')
      }

      let formData = new FormData()

      for(let i in this.formData){
        formData.append(i, this.formData[i])
      }

      this.$axios.post(`/reservation/register`, formData).then(res => {
        if (res.code == 1) {
          this.$message.success('注册成功');
          location.reload();
        } else {
          this.$message.error(res.msg);
        }
      })
    },


    // 关闭登录弹框
    closeLogin() {
      for (let i in this.formData) {
        this.formData[i] = ''
      }
      this.CloseLoginModal()
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/utils/common.scss";
</style>